import { render, staticRenderFns } from "./ModalUpg.vue?vue&type=template&id=92129f70&scoped=true"
import script from "./ModalUpg.vue?vue&type=script&lang=js"
export * from "./ModalUpg.vue?vue&type=script&lang=js"
import style0 from "./ModalUpg.vue?vue&type=style&index=0&id=92129f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92129f70",
  null
  
)

export default component.exports